// Steps
const tabs = document.querySelectorAll('[data-number]');
const tabContent = document.querySelectorAll('[data-index]');
const tabStep = document.querySelector('.js-current-number');
const tabName = document.querySelector('.js-current-name');
const totalStep = document.querySelector('.js-total-number');
const tabControls = document.querySelectorAll('.js-step-control');
const decreaseBtn = document.querySelector('[data-step="decrease"]');
const increaseBtn = document.querySelector('[data-step="increase"]');
const orderBtn = document.querySelector('#orderButton');

function initTabs() {
  let queryParams = new URLSearchParams(window.location.search);
  let index = queryParams.get('step') ? parseInt(queryParams.get('step')) : 1;
  totalStep.innerHTML = '' + tabs.length;

  function setPersonalisationUrl(index) {
    const persoBtnContainer = document.querySelector('#product-editor');

    persoBtnContainer?.addEventListener('click', function(e) {
      if (!e.target?.classList.contains('goToEditor')) {
        return;
      }

      const persoBtn = e.target;
      const urlEditor = persoBtn.getAttribute('data-editor-url');
      const urlCancel = encodeURIComponent(persoBtn.getAttribute('data-cancel-url') + '&step=' + index);
      const urlSuccess = encodeURIComponent(persoBtn.getAttribute('data-success-url') + '&step=' + index);

      document.location.href = urlEditor + '&urlCancel=' + urlCancel + '&urlSuccess=' + urlSuccess;
    });
}

  function setQueryParam(index) {
    let queryParams = new URLSearchParams(window.location.search);

    index < 1 ? queryParams.set('step', 1) : queryParams.set('step', index);

    history.replaceState(null, null, '?' + queryParams.toString());
  }

  function setActiveTab(index) {
    tabs.forEach((tab, i) => {
      tab.setAttribute('data-number', i + 1);
      if (parseInt(tab.getAttribute('data-number')) === index) {
        tab.classList.add('active');
        tabName.innerHTML = tab.innerHTML;
        tabStep.innerHTML = index;
      } else {
        tab.classList.remove('active');
      }
    });

    tabContent.forEach((content, i) => {
      content.setAttribute('data-index', i + 1);
      if (parseInt(content.getAttribute('data-index')) === index) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  function setControl(index) {
    let steps = document.querySelectorAll('[data-name]');
    let isEditable = document.querySelector('.goToEditor');
    let currentStep;
    let decrease;
    let increase;

    steps.forEach(function(step) {
      if (index === parseInt(step.getAttribute('data-number'))) {
        currentStep = step.getAttribute('data-name');
      }
    });

    if (currentStep) {
      switch (currentStep) {
        case 'pick':
          decrease = false;
          increase = true;
          break;
        case 'info':
          decrease = true;
          increase = true;
          break;
        case 'pers':
          decrease = true;
          increase = document.querySelector('#previewServiceUrl') || !isEditable;
          break;
        case 'order':
          decrease = true;
          increase = false;
          break;
      }

      !decrease ? decreaseBtn.classList.add('hidden') : decreaseBtn.classList.remove('hidden');

      if (currentStep === 'info' && index === 1) {
        decreaseBtn.classList.add('hidden');
      }

      if (currentStep === 'pers') {
        setPersonalisationUrl(index);
      }

      if (currentStep === 'pers' && !increase) {
        increaseBtn.disabled = true;
      } else {
        increaseBtn.disabled = false;
        !increase ? increaseBtn.classList.add('hidden') : increaseBtn.classList.remove('hidden');
      }

      if (currentStep === 'order') {
        orderBtn.classList.remove('hidden');
        orderBtn.style.display = 'block';

        (!document.querySelector('#previewServiceUrl') && isEditable) ? orderBtn.disabled = true : orderBtn.disabled = false;
      } else {
        orderBtn.classList.add('hidden');
      }
    }
  }

  function switchTab(event) {
    event.preventDefault();

    if (event.target.getAttribute('data-step')) {
      if (event.target.getAttribute('data-step') === 'decrease') {
        index = index - 1;
      } else {
        index = index + 1;
      }
    } else {
      index = parseInt(this.getAttribute('data-number'));
    }

    setQueryParam(index);
    setActiveTab(index);
    setControl(index);
  }

  setQueryParam(index);
  setActiveTab(index);
  setControl(index);

  tabs.forEach(tab => tab.addEventListener('click', switchTab, false));
  tabControls.forEach(control => control.addEventListener('click', switchTab, false));
}

if (tabs.length) {
  initTabs();
}
